var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiperBox"},[_c('swiper',{attrs:{"options":_vm.curOption}},[_vm._l((_vm.bannerList),function(item,index){return _c('swiper-slide',{key:index},[_c('img',{staticClass:"bannerImg",attrs:{"src":item.url,"alt":""},on:{"click":function($event){return _vm.$router.push({
            path: '/donateThird',
            query: { title: '项目详情', id: item.id, nextPath: '/home' },
          })}}})])}),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }